import { render, staticRenderFns } from "./MusicCardList.vue?vue&type=template&id=4579f5ee&scoped=true&"
import script from "./MusicCardList.vue?vue&type=script&lang=ts&"
export * from "./MusicCardList.vue?vue&type=script&lang=ts&"
import style0 from "./MusicCardList.vue?vue&type=style&index=0&id=4579f5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579f5ee",
  null
  
)

export default component.exports